import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {Project} from 'src/app/core/model/project';

@Component({
  selector: 'current-sked-default-theme-active-task-list',
  templateUrl: './current-sked-default-theme-active-task-list.component.html',
  styleUrls: ['./current-sked-default-theme-active-task-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedDefaultThemeActiveTaskListComponent {
  @Input() tasks: CurrentSkedTask[];
  @Input() projectsMap: Record<string, Project>;

  @Output() taskClick = new EventEmitter<string>();

  @ViewChild('dragScrollContainer') dragScrollContainer: ElementRef;

  mouseDown = false;
  scrolled = false;
  scrollCount = 0; // used to better UX when scrolling on active task list
  startX: number;
  scrollLeft: number;

  onTaskClick(id: string) {
    this.scrollCount = 0;
    if (this.scrolled) {
      this.scrolled = false;
      return;
    }
    this.taskClick.emit(id);
  }

  startDragging(e: MouseEvent) {
    this.mouseDown = true;
    this.startX = e.pageX - this.dragScrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.dragScrollContainer.nativeElement.scrollLeft;
  }

  stopDragging(e: MouseEvent) {
    this.mouseDown = false;
  }

  moveEvent(e: MouseEvent) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    this.scrollCount++;
    const x = e.pageX - this.dragScrollContainer.nativeElement.offsetLeft;
    this.scrolled = this.scrollCount > 10;
    const scroll = x - this.startX;
    this.dragScrollContainer.nativeElement.scrollLeft = this.scrollLeft - scroll;
  }
}
